import { clone, cloneDeep } from "lodash";
import { NOT_INITIALIZED } from "../constants/authEnums";
import {
  FETCHING_STATUS,
  SET_AUTH_STATE,
  SET_IS_AUTHENTICATION,
  SET_USER_TYPE,
  SET_USER_ID,
  SET_USER_CONFIGS,
  SET_USER,
  FETCHING_APPROVAL_LIST,
  FETCHING_APPROVAL_LIST_FAILURE,
  FETCHING_APPROVAL_LIST_SUCCESS,
  MEMBER_APPROVAL_STATUS,
  MEMBER_DECLINE_STATUS,
  UPDATE_APPROVAL_STATUS,
  UPDATE_DECLINE_STATUS,
  MOSQUE_DECLINE_STATUS,
} from "./appActionType";

const initialState = {
  authState: NOT_INITIALIZED,
  isFetching: false,
  isLoggingIn: false,
  isAuthenticated: false,
  userType: "",
  activeUserId: "",
  user: {},
  approvalList: [],
  approvalListCount: 0,
  isApprovedApproval: false,
  isApprovalDecline: false,
};

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_STATUS:
      return {
        ...state,
        isFetching: action.isFetching,
      };

    case SET_AUTH_STATE:
      return {
        ...state,
        authState: action.authState,
      };

    case SET_IS_AUTHENTICATION:
      return {
        ...state,
        isAuthenticated: action.state,
      };

    case SET_USER_ID:
      return {
        ...state,
        activeUserId: action.id,
      };

    case SET_USER_TYPE:
      return {
        ...state,
        userType: action.userType,
      };
    case SET_USER_CONFIGS:
      return {
        ...state,
        pages: action.userConfigs[0]?.pages,
      };
    case SET_USER:
      return {
        ...state,
        user: action?.user,
      };

    case FETCHING_APPROVAL_LIST:
    case FETCHING_APPROVAL_LIST_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    case FETCHING_APPROVAL_LIST_SUCCESS:
      return {
        ...state,
        approvalList: action.list,
        approvalListCount: action.count,
        isFetching: action.isFetching,
      };
    case MEMBER_APPROVAL_STATUS: {
      const listDetails = clone(state.approvalList);
      const newList = listDetails.filter(
        (item) => item._id !== action?.approvalId
      );

      return {
        ...state,
        approvalList: newList,
        approvalListCount: newList?.length,
        isApprovedApproval: true,
      };
    }

    case MEMBER_DECLINE_STATUS: {
      const listDetails = clone(state.approvalList);
      const newList = listDetails.filter(
        (item) => item._id !== action?.approvalId
      );

      return {
        ...state,
        approvalList: newList,
        approvalListCount: newList?.length,
        isApprovalDecline: true,
      };
    }
    case MOSQUE_DECLINE_STATUS: {
      const listDetails = cloneDeep(state.approvalList);
      const newList = listDetails.filter(
        (item) => item._id !== action?.approvalId
      );

      return {
        ...state,
        approvalList: newList,
        approvalListCount: newList?.length,
        isApprovalDecline: true,
      };
    }
    case UPDATE_APPROVAL_STATUS:
      return {
        ...state,
        isApprovedApproval: action.isApprovedApproval,
      };

    case UPDATE_DECLINE_STATUS:
      return {
        ...state,
        isApprovalDecline: action.isApprovalDecline,
      };
    default:
      return state;
  }
};

export default AppReducer;
